import {Stack, styled, Typography} from '@mui/material';
import {
    Call as CallIcon,
    FacebookRounded as FacebookIcon,
    Instagram as InstagramIcon,
    LocationOn as LocationIcon,
    WhatsApp as WhatsappIcon,
} from '@mui/icons-material';
import {Color} from '../../../common/theme';
import {ContactInfo} from '../../../api/models';
import {isEmpty, stripSpecialCharsForWhatsappNumber} from '../../../common/utils';

const Pressable = styled('div')({
    cursor: 'pointer',
});

export const ContactInfoComponent = ({
    contactInfo,
    showShopInfo,
}: {
    index: number;
    contactInfo: ContactInfo | undefined;
    showShopInfo: boolean;
}) => {
    if (contactInfo) {
        const {
            addressString,
            whatsappNumber,
            shopName,
            googleMapsLink,
            instagramLink,
            facebookLink,
            contactNumber,
        } = contactInfo;
        return (
            <div>
                {showShopInfo ? (
                    <>
                        <Typography
                            sx={{
                                fontWeight: 500,
                                fontFamily: 'Poppins',
                                color: Color.BLACK,
                            }}
                            variant='h6'>
                            {shopName.text}
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: 300,
                                fontFamily: 'Poppins',
                                color: Color.BLACK,
                            }}
                            variant='body2'>
                            {addressString.text}
                        </Typography>
                        <br />
                    </>
                ) : (
                    <></>
                )}
                <Stack direction='row' spacing={3}>
                    {!isEmpty(googleMapsLink.text) ? (
                        <Pressable
                            onClick={() => {
                                window.open(googleMapsLink.text);
                            }}>
                            <LocationIcon htmlColor={Color.BLACK} />
                        </Pressable>
                    ) : (
                        <></>
                    )}
                    {!isEmpty(contactNumber.text) ? (
                        <Pressable
                            onClick={() => {
                                window.open(`tel:${contactNumber.text}`);
                            }}>
                            <CallIcon htmlColor={Color.BLACK} />
                        </Pressable>
                    ) : (
                        <></>
                    )}
                    {!isEmpty(whatsappNumber.text) ? (
                        <Pressable
                            onClick={() => {
                                const number = stripSpecialCharsForWhatsappNumber(whatsappNumber.text);
                                window.open(`https://api.whatsapp.com/send?phone=${number}`);
                            }}>
                            <WhatsappIcon htmlColor={Color.BLACK} />
                        </Pressable>
                    ) : (
                        <></>
                    )}
                    {!isEmpty(facebookLink.text) ? (
                        <Pressable
                            onClick={() => {
                                window.open(facebookLink.text);
                            }}>
                            <FacebookIcon htmlColor={Color.BLACK} />
                        </Pressable>
                    ) : (
                        <></>
                    )}
                    {!isEmpty(instagramLink.text) ? (
                        <Pressable
                            onClick={() => {
                                window.open(instagramLink.text);
                            }}>
                            <InstagramIcon htmlColor={Color.BLACK} />
                        </Pressable>
                    ) : (
                        <></>
                    )}
                </Stack>
            </div>
        );
    } else {
        return null;
    }
};
